import React from 'react';
import styled from 'styled-components';
import HoverHelp from '../../components/help/hoverHelp';

const Separator = styled.span`
  @media (max-width: 600px) { display: block; }
`;

export const splitOffStatValue = label => {
  const cut = label.lastIndexOf(' ');
  if (cut === -1) return {head: '', value: label};
  return {head: label.slice(0, cut + 1), value: label.slice(cut + 1)};
};

export const PublicProfileStats = ({joinDate, userData, t}) => {
  const turnaround = userData?.avgTurnAroundTimeFor1kWords;
  const turnaroundLabel = turnaround
    ? splitOffStatValue(t('AvgTurnAroundTimePer1kWords', {count: Number(turnaround)}))
    : null;

  return (
    <div style={{fontWeight: 'normal', fontSize: '0.7em', opacity: 0.8}}>
      {t('Joined')}: {joinDate}
      {userData && (
        <>
          <Separator aria-hidden='true'> | </Separator>
          <span>{t('BooksJoinedAndCompleted', {
            joined: userData.read || 0,
            completed: userData.booksCompleted || 0,
          })}</span>
          {turnaroundLabel && (
            <>
              <Separator aria-hidden='true'> | </Separator>
              {turnaroundLabel.head}
              <span style={{whiteSpace: 'nowrap'}}>
                {turnaroundLabel.value}
                <HoverHelp label={t('WhatDoesThisMean')}
                  content={t('AvgTurnAroundTimePer1kWordsInfo')} />
              </span>
            </>
          )}
        </>
      )}
    </div>
  );
};

export default PublicProfileStats;
